export const BUTTON_ICON_SIZE = {
  small: 4,
  medium: 5,
  large: 6,
} as const
